import { ValueAccessorBase } from "./value-accessor-base";

export abstract class FormControlBase<T> extends ValueAccessorBase<T> {}
